import $foreign from "./foreign.cjs";
var unsafeGet = $foreign.unsafeGet;
export { unsafeGet };
